
export default {
    service_id: 'fakir_soft',
    template_id: 'template_npdi8r5',
    user_id: 'user_NDgVfX8GnAwP5iwpfKmy1'
}